<template>
  <div>
    <el-dialog title="Simulator Payment" v-on:closed="dialogClosed" :visible.sync="dialogFormPayment" :close-on-click-modal="false" :width="device === 'mobile' ? '95%' : '50%'" top="5vh">
      <el-form :model="formData" ref="paymentFormData" label-width="150px" size="small" :rules="formDataRule" :label-position="device === 'mobile' ? 'top' : 'right'">

        <el-form-item label="Currency">
          {{ formData.currencyCode.toUpperCase() }}
        </el-form-item>

        <el-form-item label="Payee" prop="benficiaryID">
          <el-select v-model="formData.benficiaryID" @change="selectBeneficiary">
            <el-option  v-for="item in beneficiaryList"
              :key="item.beneficiary_id"
              :label="`${item.name} [${item.currency.toUpperCase()}]`"
              :value="item.beneficiary_id"></el-option>
          </el-select>
          <el-button type="success" style="float:right" @click="addBeneficiary()">Add Beneficiary</el-button>
        </el-form-item>

        <el-form-item label="Payee name">
          {{ beneficiaryInfo.name }}
        </el-form-item>

        <el-form-item label="Account Number" v-show="formData.currencyCode==='gbp'">
          {{ beneficiaryInfo.accountnumber }}
        </el-form-item>

        <el-form-item label="Sort Code" v-show="formData.currencyCode==='gbp'">
          {{ beneficiaryInfo.sortcode }}
        </el-form-item>

        <el-form-item label="IBAN" v-show="formData.currencyCode !='gbp'">
          {{ beneficiaryInfo.iban }}
        </el-form-item>

        <el-form-item label="BIC" v-show="formData.currencyCode !='gbp'">
          {{ beneficiaryInfo.bic }}
        </el-form-item>

        <el-form-item prop="eurUrgent" label="Faster Payment" v-show="formData.currencyCode==='eur'">
          <el-switch v-model="formData.eurUrgent"></el-switch>
        </el-form-item>

        <el-form-item label="Amount" prop="amount">
          <el-input type="number" v-model="formData.amount" :min="0"></el-input>
        </el-form-item>

        <el-form-item label="Reference" prop="reference">
          <el-input v-model="formData.reference"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormPayment = false">Cancel</el-button>
        <el-button type="primary" :loading="submitingPayment" @click="submitPayment()">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { findObject } from '@/utils'
import { getBeneficiaryByProject, makePayment } from '@/api/transaction'
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data(){
    return {
      addBeneficiaryClick: false,
      dialogFormPayment: false,
      submitingPayment: false,
      beneficiaryList: [],
      beneficiaryInfo: {},
      formData:{
        "bankholderID": "",
        "benficiaryID": "",
        "amount": "",
        "currencyCode": "",
        "eurUrgent": false,
        "reference": ""
      },
      formDataRule:{
        amount:[
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          }
        ],
        reference:[
          {
            required: true,
            message: "Please enter Reference",
            trigger: "blur",
          }
        ],
        benficiaryID:[
          {
            required: true,
            message: "Please enter Payee",
            trigger: "blur",
          }
        ]
      }
    }
  },
  methods:{
    showDialogPayment(bankholderID, currency, projectUID){
      this.formData.bankholderID = bankholderID
      this.formData.currencyCode = currency
      this.getBeneficiary(projectUID, currency)
    },
    getBeneficiary(projectUID, currency){
      getBeneficiaryByProject(projectUID, currency).then(({result, data})=>{
        if(result){
          this.beneficiaryList = data
          this.dialogFormPayment = true
          this.addBeneficiaryClick = false
          this.submitingPayment = false
        }
      })
    },
    selectBeneficiary(){
      this.beneficiaryInfo = findObject(this.beneficiaryList, this.benficiaryID, 'benficiaryID')
    },
    makePayment(){
      this.submitingPayment = true
      makePayment(this.formData).then(({result})=>{
        this.submitingPayment = false
        if (result) {
            this.$notify({
              title: "Success",
              message: `Payment successfully`,
              type: "success",
              duration: 2000
            });
            this.dialogFormPayment=false;
            this.$emit("submited", true);
        }
      })
    },
    submitPayment(){
      this.$refs.paymentFormData.validate((valid) => {
          if (valid) {
            this.makePayment()
          } else {
            console.log("error submit!!");
            return false;
          }
        });
    },
    addBeneficiary(){
      this.dialogFormPayment=false;
      this.$router.push('?tab=beneficiary')
      this.addBeneficiaryClick = true
  
    },
    dialogClosed(){
      if(this.addBeneficiaryClick){
        setTimeout(()=>{
          location.reload()
        }, 400)
      }
    
    }
  }
}
</script>

<style>

</style>